module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "toTop"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTop),
      expression: "isShowTop"
    }],
    staticClass: "top"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet fa-rotate-270",
    style: ({
      color: _vm.skinColor.replace(/\sl[\S\s]+/, '')
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toTop($event)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0dba1db6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/toTop/toTop.vue
// module id = 325
// module chunks = 4